import { CompanyHomeThemeSizeConfig } from './types';

const small: CompanyHomeThemeSizeConfig = {
  companyHome: {},
};

export default small;
